import { render } from "./EditStaffModal.vue?vue&type=template&id=28f7e386"
import script from "./EditStaffModal.vue?vue&type=script&lang=js"
export * from "./EditStaffModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__